import { render } from "./test_container.vue?vue&type=template&id=3c271514"
import script from "./test_container.vue?vue&type=script&lang=js"
export * from "./test_container.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/container/test_container.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c271514"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c271514', __exports__)) {
    api.reload('3c271514', __exports__)
  }
  
  module.hot.accept("./test_container.vue?vue&type=template&id=3c271514", () => {
    api.rerender('3c271514', render)
  })

}


export default __exports__